import { ol_geom } from "@omnia/exports/openlayers";
import { IOmniaShell } from "../omnia";

export function validateGeometries(shell: IOmniaShell, topo: omnia.map.IMapTopologyService, outerGeometry: ol_geom.Geometry, splits: ol_geom.Geometry[]) {

    let diff = topo.difference(outerGeometry, splits);

    let polygons = omnia.map.getPolygonsAsArray([diff.getOpenLayersGeometry()]).filter(p => p.getArea() > 0.01);

    if (polygons.length == 1) {
        return true;
    }

    const title = "Invalid boundary";
    const msg = "The cropping cannot be split as indicated, the resulting boundary would not be a single polygon."
    omnia.shell.showWarning(shell, msg, title);

    return false;

}
